import { SyntheticEvent, useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../components/Breadcrumbs/Breadcrumbs";
import { Grid } from "@mui/material";
import UserBasicInfo from "../../components/UserBasicInfo/UserBasicInfo";

const a11yProps = (index: number) => {
  return {
    id: `user-tab-${index}`,
    "aria-controls": `user-tabpanel-${index}`,
  };
};

/**
 * Component to show user's details.
 */
const UserDetails = () => {
  const location = useLocation();
  const state = location.state;
  const { userId = "" } = useParams();

  const hoverStyles = {
    // marginLeft: '16px',
    "&:hover": {
      cursor: 'pointer',
      // border: '1px solid #e6e6e6',
    }
  }

  return (
    <>
      <BreadCrumb />
      <Grid spacing="20" container>

        <Grid item xs={12} md={6} lg={4} sx={hoverStyles}>
          <UserBasicInfo userId={userId}></UserBasicInfo>
        </Grid>

      </Grid>
    </>
  );
};

export default UserDetails;
